import { render, staticRenderFns } from "./RecordingError.vue?vue&type=template&id=321b731c&scoped=true&"
import script from "./RecordingError.vue?vue&type=script&lang=js&"
export * from "./RecordingError.vue?vue&type=script&lang=js&"
import style0 from "./RecordingError.vue?vue&type=style&index=0&id=321b731c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321b731c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
